import { TargetProtocol } from '@iotize/tap';
import { TargetConfig, S3PConfig } from '@iotize/tap/config/schema/v1';

import { GET, POST, PUT } from '../annotations';
import {
  boolean,
  enumIntToEnumStringConverter,
  stringSementicVersion,
  targetProtocol,
  uint8,
} from '../converters';
import { TapServerError } from '../tap-server-error';
import { CallContext, VirtualTap } from '../virtual-tap-server';
import { VirtualTargetDataCom } from '../virtual-target';

export class TargetService {
  protocolConfigurationData = new Uint8Array();

  get config() {
    return this.server.config;
  }

  get targetConfig(): TargetConfig {
    if (!this.config.target) {
      this.config.target = {
        type: 'MCU',
        protocol: {
          type: 'SWD',
        },
      };
    }
    return this.config.target;
  }

  get target(): VirtualTargetDataCom {
    return this.server.targetCom;
  }

  constructor(public server: VirtualTap) {
    // this.server.bindConfigToRoute({
    //     path: '/1027//1',
    //     get: true,
    //     put: true,
    //     item: this.targetConfig.protocol,
    //     key: 'type',
    //     default: 'SWD',
    //     converter: enumIntToEnumStringConverter(targetProtocol, TargetProtocol)
    // });
    this.server.bindConfigToRoute({
      path: '/1027//3',
      get: true,
      item: () => this.target,
      key: 'isConnected',
      default: false,
      converter: boolean,
    });
    this.server.bindConfigToRoute({
      path: '/1027//6',
      get: true,
      item: () => this.targetConfig,
      key: 'firmwareVersion',
      default: '1.0.0',
      converter: stringSementicVersion,
    });
  }

  @GET({
    path: '/1027//1',
    responseType: uint8,
  })
  public getProtocol() {
    const type = (this.targetConfig.protocol as any)?.type;
    if (type in TargetProtocol) {
      return TargetProtocol[type];
    }
    throw TapServerError.internalError(
      `Invalid target configuration type: ${type}`
    );
  }

  @PUT({
    path: '/1027//1',
    payloadType: uint8,
  })
  public putProtocol(protocol: CallContext<number>) {
    if (protocol.body in TargetProtocol) {
      if (!this.targetConfig.protocol) {
        this.targetConfig.protocol = {};
      }
      (this.targetConfig.protocol as any).type = TargetProtocol[
        protocol.body
      ] as any;
      return;
    }
    throw TapServerError.internalError(
      `Invalid target configuration type: ${protocol.body}`
    );
  }

  @GET({
    path: '/1027//21',
    auth: ['admin', 'supervisor'],
  })
  public getProtocolConfiguration() {
    // if (this.targetConfig.protocol?.config){

    // }
    // switch ((this.targetConfig.protocol as any)?.type){
    //     case TargetProtocolConfig:
    //         break;
    // }
    // return this.protocolConfiguration;
    return this.protocolConfigurationData;
    // throw TapServerError.notImplemented();
  }
  @POST({
    path: '/1027//21',
  })
  public postProtocolConfiguration(context: CallContext<Uint8Array>) {
    this.protocolConfigurationData = context.body;
  }

  @PUT({
    path: '/1027//21',
  })
  public putProtocolConfiguration(context: CallContext<Uint8Array>) {
    this.postProtocolConfiguration(context);
  }

  // @POST({
  //     path: '/1027//1'
  // })
  // public postProtocol(p) {
  //     return 'SWD';
  // }

  @POST({
    path: '/1027//3',
  })
  public connectToTarget() {
    // this.isConnected = true;
    this.target.connect();
  }

  @POST({
    path: '/1027//4',
  })
  public disconnectTarget() {
    // this.isConnected = false;
    this.target.disconnect();
  }
}
